// frontend/packs/critical-top-scripts.js

import Rails from 'rails-ujs';
import Turbolinks from 'turbolinks';
import applyTurbolinksErrorsPatch from '../lib/turbolinks-errors-patch';
import applyTurbolinksScrollPatch from '../lib/turbolinks-scroll-patch';

Rails.start();
Turbolinks.start();

applyTurbolinksErrorsPatch();
applyTurbolinksScrollPatch();
